import React from 'react';
import ggAdyen from 'ggApp/modules/adyen';

import Card from 'ggApp/shared/icons/Card';
import VisaIcon from 'ggApp/shared/icons/Visa';
import SepaIcon from 'ggApp/shared/icons/Sepa';
import MasterCardIcon from 'ggApp/shared/icons/MasterCard';
import PayPalIcon from 'ggApp/shared/icons/PayPal';

const { ADYEN_PAYMENT, ADYEN_PAYMENT_CC, ADYEN_PAYMENT_SEPA } = ggAdyen.constants;

const PAYMENT_SERVICE_METHOD_TYPE = 'Payments::UserPaymentMethod';

const paymentIcon = (name) => {
    switch (name.toLowerCase()) {
        case 'visa':
            return <VisaIcon />;

        case 'mastercard':
            return <MasterCardIcon />;

        default:
            return <Card />;
    }
};

export const detectPayment = (paymentMethod) => {
    const { id, meta, type, flowType, contractType, paymentGatewayType } = paymentMethod;

    const {
        account_name: accountName,
        credit_card_brand: creditCardBrand,
        credit_card_last_4_digits: cardNumberLast4Digits,
        iban_last_2_digits: IbanLast2Digits,
        iban_last_4_digits: IbanLast4Digits,
    } = meta || {};

    let paymentName;
    let paymentDescription = paymentMethod?.description ?? '';
    let icon = <Card />;

    switch (type) {
        case 'CreditCard':
            paymentName = 'Credit card / Debit card';
            paymentDescription = `Ending: ${paymentMethod.last_digits}`;
            break;

        case 'PaypalExpressCheckout':
            icon = <PayPalIcon />;
            paymentName = 'Paypal';
            paymentDescription = paymentMethod.payer_email;
            break;

        case ADYEN_PAYMENT:
            if (contractType === ADYEN_PAYMENT_CC) {
                paymentName = 'Credit / Debit card';
                paymentDescription = `Ending: ${paymentMethod.number}`;
            } else if (contractType === ADYEN_PAYMENT_SEPA) {
                icon = <SepaIcon />;
                paymentName = 'SEPA Direct Debit';
                paymentDescription = `IBAN ends with: ${paymentMethod.iban}`;
            }
            break;

        case PAYMENT_SERVICE_METHOD_TYPE:
            if (flowType === 'credit-card') {
                paymentName = creditCardBrand || paymentGatewayType;
                icon = paymentIcon(creditCardBrand || 'card');
                paymentDescription = `Ending: ${cardNumberLast4Digits}`;
            } else if (flowType === 'redirect') {
                if (paymentGatewayType && paymentGatewayType.toLowerCase() === 'paypal') {
                    paymentName = 'PayPal';
                    icon = <PayPalIcon />;
                    paymentDescription = accountName;
                }

                if (paymentGatewayType && paymentGatewayType.toLowerCase() === 'sepa') {
                    paymentName = 'SEPA direct debit';
                    icon = <SepaIcon />;
                    paymentDescription = `IBAN ends with: ${IbanLast4Digits || IbanLast2Digits}`;
                }
            }
            break;

        default:
            break;
    }

    return {
        id,
        type,
        icon,
        name: paymentName,
        description: paymentDescription,
    };
};
